import template from './project-switch-modal.pug';

export const ProjectSwitchModalComponent = {
  template,
  bindings: {
    resolve: '<',
    modalInstance: '<'
  },
  controller: class ProjectSwitchModalComponent {
    constructor(Project, $async, $log, Settings, User, $state, $sessionStorage) {
      'ngInject';

      this.Project = Project;
      this.Settings = Settings;
      this.User = User;
      this.$log = $log;
      this.$state = $state;
      this.$sessionStorage = $sessionStorage;
      this.fetch = $async(this.fetch.bind(this));
      this.update = $async(this.update.bind(this));
      this.getUserProject = $async(this.getUserProject.bind(this));
    }

    $onInit() {
      this.getUserProject();
      this.fetch();
    }

    async update(project) {
      try {
        const resp = await this.Settings.update({ module: 'project', key: 'default', value: project.id });
        if (resp) {
          this.$sessionStorage.project = project.id;
          this.modalInstance.close(project);
          this.$state.reload();
        }
      } catch (e) {
        this.$log.error(e);
      }
    }

    async getUserProject() {
      try {
        const resp = await this.User.find(this.User.currentId(), { fields: { user: ['id', 'name', 'default_project_id'] } });
        this.selectedProject = resp.default_project_id;
      } catch (e) {
        this.$log.error(e);
      }
    }

    async fetch() {
      try {
        this.projects = await this.Project.getGroups();
      } catch (e) {
        this.$log.error(e);
      }
    }

    goToSettings() {
      this.close();
      this.$state.go('main.settings.projects');
    }

    close() {
      this.modalInstance.close(void(0));
    }

  }
};
